var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { screens } from "tailwindcss/defaultTheme";
export class SearchFormHandler {
  constructor() {
    __publicField(this, "rootElement", document.querySelector(".main-bar__search"));
    __publicField(this, "closeSearchBtn", document.getElementById("close-search-btn"));
    __publicField(this, "searchToggleBtn", document.getElementById("search-toggle-btn"));
    __publicField(this, "searchFormElement", document.getElementById("form-search_topbar"));
    __publicField(this, "searchInputElement", document.getElementById("input-search"));
    if (this.rootElement) {
      this.bindEvents();
      this.initListeners();
    }
  }
  bindEvents() {
    this.handleCloseBtnClick = this.handleCloseBtnClick.bind(this);
    this.handleResizeEvent = this.handleResizeEvent.bind(this);
    this.handleSearchInputKeyboardEvent = this.handleSearchInputKeyboardEvent.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleSearchTriggerClickEvent = this.handleSearchTriggerClickEvent.bind(this);
  }
  initListeners() {
    window.matchMedia(`(min-width: ${screens.lg})`).addEventListener("change", this.handleResizeEvent);
    document.addEventListener("click", this.handleClickOutside);
    this.searchToggleBtn.addEventListener("click", this.handleSearchTriggerClickEvent);
    this.searchInputElement.addEventListener("keydown", this.handleSearchInputKeyboardEvent);
    this.closeSearchBtn.addEventListener("click", this.handleCloseBtnClick);
  }
  close() {
    this.searchToggleBtn.ariaExpanded = "false";
    this.searchFormElement.classList.remove("open");
    this.searchToggleBtn.setAttribute("aria-label", this.searchToggleBtn.dataset.openHelpText);
  }
  isOpen() {
    return this.searchToggleBtn.ariaExpanded === "true";
  }
  open() {
    this.searchToggleBtn.ariaExpanded = "true";
    this.searchFormElement.classList.add("open");
    requestAnimationFrame(() => this.searchFormElement.querySelector("input").focus());
    this.searchToggleBtn.setAttribute("aria-label", this.searchToggleBtn.dataset.closeHelpText);
  }
  handleCloseBtnClick() {
    this.close();
    this.searchToggleBtn.focus();
  }
  handleResizeEvent(event) {
    event.matches && this.close();
  }
  handleClickOutside(event) {
    if (this.isOpen() && !this.rootElement.contains(event.target)) {
      this.close();
    }
  }
  handleSearchTriggerClickEvent() {
    this.isOpen() ? this.close() : this.open();
  }
  handleSearchInputKeyboardEvent(event) {
    if (event.code === "Escape") {
      this.close();
      this.searchToggleBtn.focus();
    }
  }
}
export function createSearchFormHandler() {
  return new SearchFormHandler();
}
